import { useState, useEffect, useCallback } from 'react';

type Theme = 'dark' | 'light';

const THEME_KEY = 'chm-theme';

function getStoredTheme(): Theme {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'light') return 'light';
    return 'dark';
  } catch {
    return 'dark';
  }
}

function applyThemeClass(theme: Theme) {
  const root = document.documentElement;
  if (theme === 'light') {
    root.classList.add('light');
  } else {
    root.classList.remove('light');
  }
}

export default function useTheme() {
  const [theme, setTheme] = useState<Theme>(getStoredTheme);

  // Apply on mount and when theme changes
  useEffect(() => {
    applyThemeClass(theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next: Theme = prev === 'dark' ? 'light' : 'dark';
      try {
        localStorage.setItem(THEME_KEY, next);
      } catch { /* noop */ }
      return next;
    });
  }, []);

  return { theme, toggle, isLight: theme === 'light' };
}